import { render } from "./AddCategory.vue?vue&type=template&id=662a4983"
import script from "./AddCategory.vue?vue&type=script&lang=js"
export * from "./AddCategory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\lotus-Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__